import { useSelector } from "react-redux";
import ProductsService from "../../../../../services/ProductsService";
import ConfirmModal from "../../../../common/ConfirmModal";
import { Translate } from "../../../../Enums/Tranlate";
import unpinIcon from "../../../../../images/icons/unpin.svg";
import { useState } from "react";
import MatchesService from "../../../../../services/MatchesService";
import { toast } from "react-toastify";

const CardItem = ({ item, index, setShouldUpdate }) => {
	const productsService = new ProductsService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const lang = useSelector((state) => state.auth?.lang);
	const [changeModal, setChangeModal] = useState(false);

	const changeStatusToggle = () => {
		if (item?.type === "Product") {
			productsService?.changePin("removePin", item?.product_id).then((res) => {
				if (res?.status) {
					toast.success("Pin Changed Successfully");
					setShouldUpdate((prev) => !prev);
				}
			});
		} else {
			let type =
				item?.type === "Match" ? "public/removePin" : "tournament/removePin";
			new MatchesService()?.changePin(type, item?.match_id).then((res) => {
				if (res?.status) {
					toast.success("Pin Changed Successfully");
					setShouldUpdate((prev) => !prev);
				}
			});
		}
	};

	return (
		<tr key={index}>
			<td className="text-wrap-mode">{item?.type}</td>
			<td className="text-wrap-mode">{item?.pin_date?.split("T")[0]}</td>
			<td className="text-wrap-mode">{item?.pin_date?.slice(11, 16)}</td>
			<td>
				{(isExist("update_pin_market_place") ||
					isExist("delete_pin_market_place")) && (
					<img
						src={unpinIcon}
						onClick={() => {
							setChangeModal(true);
						}}
						className="cursor-pointer"
						alt="edit"
						width={24}
					/>
				)}
			</td>
			{changeModal && (
				<ConfirmModal
					open={changeModal}
					title={item?.type}
					body={
						lang === "en"
							? `are you sure about changing Pin for this ${item?.type}?`
							: `هل أنت متأكد من تغيير التثبيت لهذه ${
									Translate[lang][item?.type]
							  } ؟`
					}
					button={Translate[lang].submit}
					submitButton={changeStatusToggle}
					onCloseModal={() => setChangeModal(false)}
				/>
			)}
		</tr>
	);
};
export default CardItem;
